// ============================================
// CONFIG LANDING PAGE — ENGULF SUMMIT 2026
// ============================================

// Link Telegram admin (semua butang CTA)
export const TELEGRAM_URL = "https://t.me/m/eO_LnKvkZjQ1";

// Meta Pixel ID — dipasang terus dalam public/index.html (head).
export const META_PIXEL_ID = "950428814807062";

// Event "Subscribe" — HANYA apabila pelawat klik butang Telegram.
export const trackTelegramClick = (location) => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("track", "Subscribe", {
            content_name: "Telegram CTA",
            cta_location: location,
        });
    }
};

// Event "CompleteRegistration" — HANYA selepas borang pendaftaran
// berjaya dihantar & disimpan dalam backend (bukan semasa load).
export const trackCompleteRegistration = () => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
        window.fbq("track", "CompleteRegistration", {
            content_name: "Seminar Registration Form",
        });
    }
};

// Scroll lancar ke seksyen borang pendaftaran (guna Lenis jika aktif).
export const scrollToRegistration = () => {
    const el = document.getElementById("registration-form");
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};
